import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices
import accountInfo from "./slices/accountInfo";
import apiDataReducer from "./slices/apiData";
import askDostChatReducer from "./slices/askDostChat";
import bankReconciliationDefaultQuery from "./slices/bankReconciliationDefaultQuery";
import bumperStates from "./slices/bumper";
import calendarReducer from "./slices/calendar";
import cartReducer from "./slices/cart";
import chatReducer from "./slices/chat";
import configuration from "./slices/configuration";
import credential from "./slices/credentials";
import defaultQuery from "./slices/defaultQuery";
import externalIdentities from "./slices/externalIdentities";
import mailReducer from "./slices/mail";
import modalToggle from "./slices/modal";
import organization from "./slices/organization";
import predefinedValueFiltersReducer from "./slices/predefinedValueFilters";
import reviewScreenReducer from "./slices/reviewScreen";
import statesReducer from "./slices/states";
import stepperReducer from "./slices/stepper";

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const productPersistConfig = {
  key: "product",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

const credentialPersistConfig = {
  key: "user",
  storage,
  keyPrefix: "redux-",
  whitelist: ["userCred", "userTokenDecode"],
};

const organizationPersistConfig = {
  key: "organization",
  storage,
  keyPrefix: "redux-",
  whitelist: ["org"],
};

const cartPersistConfig = {
  key: "cart",
  storage,
  keyPrefix: "redux-",
  whitelist: ["cartState"],
};

const modalPersistConfig = {
  key: "modal",
  storage,
  keyPrefix: "redux-",
  whitelist: [
    "modalState",
    "checkTooltip",
    "tooltipToggleFinance",
    "tooltipToggleReview",
  ],
};

const statesReducerConfig = {
  key: "States",
  storage,
  keyPrefix: "redux-",
  whitelist: ["isEmailHidden"],
};

const apiDataReducerConfig = {
  key: "ApiData",
  storage,
  keyPrefix: "redux-",
  whitelist: ["dashboard"],
};

const bumperStatesReducerConfig = {
  key: "BumperDialog",
  storage,
  keyPrefix: "redux-",
  whitelist: ["steps", "progressBarPer"],
};

const configurationConfig = {
  key: "Configuration",
  storage,
  keyPrefix: "redux-",
  whitelist: ["configurationDetail"],
};

const externalIdentitiesConfig = {
  key: "externalIdentities",
  storage,
  keyPrefix: "redux-",
  whitelist: ["externalIdentities"],
};
const defaultQueryConfig = {
  key: "defaultQuery",
  storage,
  keyPrefix: "redux-",
  whitelist: ["documentList", "documentListByPath", "bankReconciliation"],
};

const bankReconciliationDefaultQueryConfig = {
  key: "bankReconciliationDefaultQuery",
  storage,
  keyPrefix: "redux-",
  whitelist: ["query", "enable"],
};

const accountInfoConfig = {
  key: "accountInfo",
  storage,
  keyPrefix: "redux-",
  whitelist: ["accountInfo"],
};

const askDostChatConfig = {
  key: "askDostChat",
  storage,
  keyPrefix: "redux-",
  // "odoo" is the mocked integration connection state (UI-only for now) —
  // whitelisted so "Connected" survives reload like a real integration would.
  whitelist: ["messages", "odoo"],
};

const predefinedValueFiltersConfig = {
  key: "predefinedValueFilters",
  storage,
  keyPrefix: "redux-",
  whitelist: ["filtersByField"],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  reviewScreen: reviewScreenReducer,
  modalToggle: persistReducer(modalPersistConfig, modalToggle),
  credential: persistReducer(credentialPersistConfig, credential),
  organization: persistReducer(organizationPersistConfig, organization),
  cart: persistReducer(cartPersistConfig, cartReducer),
  stepper: stepperReducer,
  states: persistReducer(statesReducerConfig, statesReducer),
  apiData: persistReducer(apiDataReducerConfig, apiDataReducer),
  bumper: persistReducer(bumperStatesReducerConfig, bumperStates),
  configuration: persistReducer(configurationConfig, configuration),
  defaultQuery: persistReducer(defaultQueryConfig, defaultQuery),
  bankReconciliationDefaultQuery: persistReducer(
    bankReconciliationDefaultQueryConfig,
    bankReconciliationDefaultQuery,
  ),
  externalIdentities: persistReducer(
    externalIdentitiesConfig,
    externalIdentities,
  ),
  accountInfo: persistReducer(accountInfoConfig, accountInfo),
  askDostChat: persistReducer(askDostChatConfig, askDostChatReducer),
  predefinedValueFilters: persistReducer(
    predefinedValueFiltersConfig,
    predefinedValueFiltersReducer,
  ),
});

export { rootPersistConfig, rootReducer };
